import { InterceptorClient } from "../../interceptor/interceptorClient";
import {
  ADD_TO_CART_URI,
  DELETE_CART_URI,
  GET_CART_URI,
  GET_PERSONALIZATION_DETAILS,
  SET_CART_ITEM_URI,
  SET_FNP_WALLET_SELECTION,
  UPDATE_ADD_ON_QUANTITY,
  UPDATE_BASE_PRODUCT_QUANTITY,
} from "./constant";
const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

/**
 *
 * @returns
 */
export const getCartService = async ({ payload, isDomestic, lat, long }) => {
  try {
    const res = await InterceptorClient.getGatewayInstance().post(
      null,
      GET_CART_URI({ lite: payload, lat, long }),
      false,
      isDomestic ? { "x-api-version": "v1.4" } : {},
    );
    return res;
  } catch (err) {
    throw new Error(err.message);
  }
};

/**
 * API for the data for home page
 * @returns
 */
export const addToCartService = async (params, isDomestic) => {
  return await InterceptorClient.getFNTSInstance(baseUrl).post(
    params,
    `${ADD_TO_CART_URI()}`,
    false,
    isDomestic ? { "x-api-version": "v1.4" } : {},
  ); //second parameter for mock
};

/**
 *
 * @returns
 */
export const setCartItemValuesService = async (params) => {
  return await InterceptorClient.getFNTSInstance(baseUrl).post(params, `${SET_CART_ITEM_URI()}`, false, {
    "x-api-version": "v1.4",
  });
};

/**
 *
 * @returns
 */
export const deleteCartItemService = async (params) => {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${DELETE_CART_URI()}?${params}`, false, null, {
    "x-api-version": "v1.4",
  }); //second parameter for mock
};

/**
 *
 * @returns
 */
export const updateAddOnQuantity = async (params) => {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${UPDATE_ADD_ON_QUANTITY()}?${params}`, false); //second parameter for mock
};

/**
 * Updates base product quantity on delivery address checkout.
 *
 * @param {string} params - URL-encoded form payload.
 * @returns {Promise<Object>} API response.
 */
export const updateBaseProductQuantity = async (params) => {
  return await InterceptorClient.getFNTSInstance(baseUrl).post(params, `${UPDATE_BASE_PRODUCT_QUANTITY()}`, false, {
    "x-api-version": "v1.4",
  });
};

/**
 *
 * @returns
 */
export const viewPersonalizationDetails = async (orderItemSeqId) => {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_PERSONALIZATION_DETAILS(orderItemSeqId)}`, false); //second parameter for mock
};

/**
 * API for setting the FNP wallet selection.
 *
 * @param params - The parameters to be sent with the request.
 * @returns {object} - returns object of promise responses for each API
 */
export const setFNPWalletSelection = async (params) => {
  try {
    const encodedPayload = new URLSearchParams(params).toString();
    const response = await InterceptorClient.getFNTSInstance(baseUrl).post(
      encodedPayload,
      SET_FNP_WALLET_SELECTION(),
      false,
      {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    );
    return response;
  } catch (err) {
    return { error: err };
  }
};
